/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationMemberInvitationState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_STATE_ENTITY_NAME = 'ixm.userauth.v1.OrganizationMemberInvitation';
export const ixmUserauthV1OrganizationMemberInvitationStateEntity = new schema.Entity<IxmUserauthV1OrganizationMemberInvitationState>(IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_STATE_ENTITY_NAME, {}, { idAttribute: 'invitationId' });

